import { AbstractObserver } from 'utils/abstract-classes/abstract-observer'
import { ApiService } from 'services/api/api.service'
import { ATTR_NAME } from 'constants/attr-name'
import { CLASS_NAME } from 'constants/class-names'
import { logger } from 'utils/system/logger'

export class Weather extends AbstractObserver {
    public constructor(protected el: HTMLElement) {
        super(el)
        this.activateObserver()
    }

    /**
     * Load the data and show the widget (if data was returned)
     */
    public render(): void {
        const region = this.el.getAttribute(ATTR_NAME.widget.weather.region)
        const city = this.el.getAttribute(ATTR_NAME.widget.weather.city)
        const apiService = new ApiService()

        this.el.hidden = true

        if (region && city) {
            // Retrieve the data based on city and region for use in the widget
            apiService
                .fetchWeatherForRegionAndCity(region, city)
                .then((weatherData: HTMLElement) => {
                    if (weatherData) {
                        // Insert weather data element on page
                        const lastWidgetElement = this.getElement(
                            `.${CLASS_NAME.weather.last}`,
                            this.el
                        )
                        if (lastWidgetElement) {
                            this.el.insertBefore(weatherData, lastWidgetElement)
                        }
                        // Display widget once data finished loading
                        this.el.hidden = false
                    }
                })
                .catch((err) => {
                    logger('error', err)
                })
        }
    }
}
